<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <!-- Header -->
    <div
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
        style="padding-bottom: 0 !important;">
        <div class="flex-1 min-w-0">
            <!-- Breadcrumbs -->
            <div>
                <ng-content select="[breadcrumbs]"></ng-content>
            </div>
            <!-- Title -->
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    <ng-content select="[heading]"></ng-content>
                </h2>
            </div>
        </div>
        <!-- Actions -->
        <div class="flex flex-shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <ng-content select="[icons]"></ng-content>
        </div>
    </div>

    <!-- Main -->
    <div
        cdkScrollable
        class="flex-auto -mt-16 p-6 sm:p-10 overflow-y-auto">

        <!-- CONTENT GOES HERE -->
        <div>
            <ng-content select="[content]"></ng-content>
        </div>

    </div>

</div>
